import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import SectionHeading from "../../../components/SectionHeading";
import { homeIcons } from "../../Home/homeIcons";
import { industriesContent } from "./certificationContent";

const cardVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: "easeOut" } },
};

const CertificationIndustries = () => (
  <section
    className="bg-white py-14 lg:py-20"
    aria-labelledby="certification-industries-heading"
  >
    <div className="brand-col">
      <SectionHeading
        id="certification-industries-heading"
        title={industriesContent.title}
        subtitle={industriesContent.intro}
        /* a lead-in sentence, not a sub-heading — the document gives this
           section none */
        subtitleAs="p"
        subtitleClassName="mx-auto max-w-2xl text-sm md:text-base leading-relaxed text-gray-600"
      />
      <motion.ul
        className="grid list-none grid-cols-1 gap-6 p-0 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.1 }}
        variants={{ visible: { transition: { staggerChildren: 0.07 } } }}
      >
        {industriesContent.groups.map((group) => {
          const Icon = homeIcons[group.icon];
          return (
            <motion.li
              key={group.title}
              variants={cardVariants}
              className="brand-card"
            >
              <Link
                to={group.to}
                className="block h-full p-6 lg:p-8 rounded-[inherit] text-inherit hover:text-inherit focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--brand-orange)]"
              >
                <div className="flex items-center gap-4">
                  <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-[var(--brand-primary)] text-white shadow-md">
                    <Icon aria-hidden="true" className="h-5 w-5" />
                  </span>
                  <h3 className="text-lg font-bold text-gray-900">
                    {group.title}
                  </h3>
                </div>
                <ul className="mt-5 space-y-2">
                  {group.items.map((item) => (
                    <li key={item} className="flex items-start gap-3">
                      <span
                        aria-hidden="true"
                        className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-[var(--brand-orange)]"
                      />
                      <span className="text-sm md:text-base text-gray-700">
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </Link>
            </motion.li>
          );
        })}
      </motion.ul>
    </div>
  </section>
);

export default CertificationIndustries;
